var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("drawer", {
        ref: "filterDrawer",
        scopedSlots: _vm._u([
          {
            key: "tabs",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "flex bg-white",
                    staticStyle: { width: "100%", "align-items": "center" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex1",
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-tabs",
                          {
                            on: {
                              "tab-click": function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.device_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "device_type", $$v)
                              },
                              expression: "listQuery.device_type",
                            },
                          },
                          [
                            _c("el-tab-pane", {
                              attrs: { label: "全部设备", name: "-1" },
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.deviceNameObj, function (item, index) {
                              return _c("el-tab-pane", {
                                attrs: { label: index, name: "" + item + "" },
                              })
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-top": "4px",
                          "border-bottom": "1px solid #E4E7ED",
                          "margin-right": "10px",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              plain: "",
                            },
                            on: { click: _vm.toggleExtraTabs },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.showExtraTabs ? "收起" : "查看订单更多信息"
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.checkRoles(["terminal", "partner"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.stealDel()
                                  },
                                },
                              },
                              [_vm._v("\n            掉单恢复")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.checkRoles(["merchants"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push({
                                      path: "/order/scanCode",
                                    })
                                  },
                                },
                              },
                              [_vm._v("扫码记录")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkRoles(["partner"]) &&
                        _vm.listQuery.order_type == 3
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "small",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deliver()
                                  },
                                },
                              },
                              [_vm._v("批量发货")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "defult",
            fn: function () {
              return [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单单号:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.order_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "order_sn", $$v)
                        },
                        expression: "form.order_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "手机号码:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.custom_mobile,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "custom_mobile", $$v)
                        },
                        expression: "form.custom_mobile",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { label: "用户ID:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_uid", $$v)
                        },
                        expression: "form.search_uid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-down",
                    attrs: { label: "商户名称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "store_name", $$v)
                        },
                        expression: "form.store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-down",
                    attrs: { label: "二维码:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "goods_sn", $$v)
                        },
                        expression: "form.goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-down",
                    attrs: { label: "交易单号:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.transaction_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "transaction_id", $$v)
                        },
                        expression: "form.transaction_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showNfcNoFilter
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "IC充电卡:" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "储值卡卡号" },
                          model: {
                            value: _vm.form.nfc_no,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "nfc_no", $$v)
                            },
                            expression: "form.nfc_no",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      { attrs: { type: "primary", "native-type": "submit" } },
                      [
                        _vm._v("查询"),
                        _c("i", {
                          staticClass: "el-icon-search el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.toQuery(1)
                          },
                        },
                      },
                      [
                        _vm._v("重置"),
                        _c("i", {
                          staticClass: "el-icon-refresh el-icon--right",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.outTable()
                          },
                        },
                      },
                      [
                        _vm._v("导出"),
                        _c("i", { staticClass: "el-icon-male el-icon--right" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.showOrderStatsDialog()
                          },
                        },
                      },
                      [
                        _vm._v("订单交易总览"),
                        _c("i", { staticClass: "el-icon-male el-icon--right" }),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "more",
            fn: function () {
              return [
                _vm.checkRoles(["terminal"])
                  ? _c("sel-plat", {
                      attrs: { listQuery: _vm.listQuery },
                      on: {
                        change: function ($event) {
                          return _vm.toQuery()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.listQuery.son_id > 0
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "订单归属:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.search_user_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "search_user_type", $$v)
                              },
                              expression: "listQuery.search_user_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "代理本人", value: 0 },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "代理下级", value: 1 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单来源:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.mini_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "mini_type", $$v)
                          },
                          expression: "listQuery.mini_type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "微信", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "支付宝", value: "2" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "异常退款:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.is_cancel_commission,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "is_cancel_commission", $$v)
                          },
                          expression: "listQuery.is_cancel_commission",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "" },
                        }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "否", value: "0" } }),
                        _vm._v(" "),
                        _c("el-option", { attrs: { label: "是", value: "1" } }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                false
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "支付类型:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.pay_type,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "pay_type", $$v)
                              },
                              expression: "listQuery.pay_type",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全部", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "押金", value: "1" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "免押", value: "2" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "余额", value: "3" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "储值卡", value: "4" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "会员卡", value: "5" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "支付类型:" } },
                  [
                    _c(
                      "el-select",
                      {
                        on: {
                          change: function ($event) {
                            return _vm.toQuery()
                          },
                        },
                        model: {
                          value: _vm.listQuery.new_pay_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listQuery, "new_pay_type", $$v)
                          },
                          expression: "listQuery.new_pay_type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "全部", value: "0" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "微信支付", value: "1" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "微信余额", value: "3" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "微信免押", value: "5" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "免费店员", value: "6" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "支付宝支付", value: "2" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "支付宝余额", value: "9" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "支付宝免押", value: "4" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "微信余额合并", value: "7" },
                        }),
                        _vm._v(" "),
                        _c("el-option", {
                          attrs: { label: "支付宝余额合并", value: "8" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { label: "用户ID:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.search_uid,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "search_uid", $$v)
                        },
                        expression: "form.search_uid",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-lg-and-up",
                    attrs: { label: "商户名称:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.store_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "store_name", $$v)
                        },
                        expression: "form.store_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xg-and-up",
                    attrs: { label: "设备SN:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.goods_sn,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "goods_sn", $$v)
                        },
                        expression: "form.goods_sn",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticClass: "hidden-xl-only",
                    attrs: { label: "交易单号:" },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.transaction_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "transaction_id", $$v)
                        },
                        expression: "form.transaction_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "用户昵称:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.custom_nick_name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "custom_nick_name", $$v)
                        },
                        expression: "form.custom_nick_name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商户单号:" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.form.out_order_no,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "out_order_no", $$v)
                        },
                        expression: "form.out_order_no",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "行业分类:" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.categoryList,
                        "show-all-levels": false,
                        props: { expandTrigger: "hover" },
                      },
                      model: {
                        value: _vm.cat_id,
                        callback: function ($$v) {
                          _vm.cat_id = $$v
                        },
                        expression: "cat_id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "所在地区:" } },
                  [
                    _c("el-cascader", {
                      attrs: {
                        options: _vm.areaList,
                        "show-all-levels": false,
                        props: { expandTrigger: "hover", checkStrictly: true },
                      },
                      model: {
                        value: _vm.search_regions_tag,
                        callback: function ($$v) {
                          _vm.search_regions_tag = $$v
                        },
                        expression: "search_regions_tag",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "时间筛选:" } }, [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "开始",
                          "value-format": "timestamp",
                          "picker-options": _vm.beginOptions,
                        },
                        model: {
                          value: _vm.form.begin,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "begin", $$v)
                          },
                          expression: "form.begin",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-5 mr-5" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          placeholder: "结束",
                          "value-format": "timestamp",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.form.end,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end", $$v)
                          },
                          expression: "form.end",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.checkHidRole("storePcddgb")
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "是否掉单:" } },
                      [
                        _c(
                          "el-select",
                          {
                            on: {
                              change: function ($event) {
                                return _vm.toQuery()
                              },
                            },
                            model: {
                              value: _vm.listQuery.is_steal_order,
                              callback: function ($$v) {
                                _vm.$set(_vm.listQuery, "is_steal_order", $$v)
                              },
                              expression: "listQuery.is_steal_order",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "全部", value: "" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "否", value: "0" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "是", value: "1" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "p-5" },
        [
          _vm.showExtraTabs
            ? _c(
                "div",
                {
                  staticClass: "flex bg-white",
                  staticStyle: { padding: "10px 0" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex1 flex",
                      staticStyle: {
                        "align-items": "center",
                        "flex-wrap": "nowrap",
                        "overflow-x": "auto",
                      },
                    },
                    [
                      _vm.checkHidRole("meorderStat")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "4",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "4"
                                  _vm.typeClick({ name: "4" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "全部(" +
                                    _vm._s(_vm.numInfo.total_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.total_order_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_syz")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "1",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "1"
                                  _vm.typeClick({ name: "1" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "使用中(" +
                                    _vm._s(_vm.numInfo.renting_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.numInfo.renting_order_amount || 0
                                    )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_jrdd")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "0",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "0"
                                  _vm.typeClick({ name: "0" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "今日订单(" +
                                    _vm._s(_vm.numInfo.today_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.today_order_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_ywc")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "2",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "2"
                                  _vm.typeClick({ name: "2" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "已完成(" +
                                    _vm._s(_vm.numInfo.finish_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.finish_order_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_csdd")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "3",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "3"
                                  _vm.typeClick({ name: "3" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "超时订单(" +
                                    _vm._s(
                                      _vm.numInfo.overtime_order_num || 0
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.numInfo.overtime_order_amount || 0
                                    )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_zjsb")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "5",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "5"
                                  _vm.typeClick({ name: "5" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "租借失败(" +
                                    _vm._s(_vm.numInfo.fail_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.fail_order_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_kksb")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "7",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "7"
                                  _vm.typeClick({ name: "7" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "扣款失败(" +
                                    _vm._s(
                                      _vm.numInfo.deduction_failed_num || 0
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.numInfo.deduction_failed_amount || 0
                                    )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_sqtk")
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "8",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "8"
                                  _vm.typeClick({ name: "8" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "申请退款(" +
                                    _vm._s(_vm.numInfo.refund_apply_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.refund_apply_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_ptzz") &&
                      _vm.checkRoles(["partner"]) &&
                      _vm.agentInfo.steal_order_right == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "9",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "9"
                                  _vm.typeClick({ name: "9" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "平台增值(" +
                                    _vm._s(
                                      _vm.numInfo.stealed_pt_order_num || 0
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.numInfo.stealed_pt_order_amount || 0
                                    )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_dlzz") &&
                      _vm.agentInfo.steal_order_right == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "10",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "10"
                                  _vm.typeClick({ name: "10" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "代理增值(" +
                                    _vm._s(
                                      _vm.numInfo.stealed_dl_order_num || 0
                                    ) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.numInfo.stealed_dl_order_amount || 0
                                    )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_ptzz") &&
                      _vm.checkRoles(["partner"]) &&
                      _vm.agentInfo.steal_order_right == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "11",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "11"
                                  _vm.typeClick({ name: "11" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "代理收益(" +
                                    _vm._s(_vm.numInfo.ag_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.ag_order_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_dlzz") &&
                      _vm.agentInfo.steal_order_right == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "12",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "12"
                                  _vm.typeClick({ name: "12" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "代理异常退款(" +
                                    _vm._s(_vm.numInfo.ag_cancel_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.ag_cancel_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_ptzz") &&
                      _vm.checkRoles(["partner"]) &&
                      _vm.agentInfo.steal_order_right == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "13",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "13"
                                  _vm.typeClick({ name: "13" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "商户收益(" +
                                    _vm._s(_vm.numInfo.store_order_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.store_order_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkHidRole("meorder_dlzz") &&
                      _vm.agentInfo.steal_order_right == 1
                        ? _c(
                            "div",
                            {
                              staticClass: "tab-item",
                              class: {
                                active: _vm.listQuery.order_type == "14",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.listQuery.order_type = "14"
                                  _vm.typeClick({ name: "14" })
                                },
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "商户异常退款(" +
                                    _vm._s(_vm.numInfo.store_cancel_num || 0) +
                                    ")"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "￥" +
                                    _vm._s(_vm.numInfo.store_cancel_amount || 0)
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "bg-white" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "order_table",
                  staticClass: "ptd-5",
                  attrs: {
                    id: "order_table",
                    data: _vm.list,
                    "max-height": _vm.tableMaxH,
                    stripe: "",
                    "highlight-current-row": "",
                    "element-loading-text": "Loading",
                  },
                  on: { "selection-change": _vm.selOrder },
                },
                [
                  _vm.checkRoles(["partner"])
                    ? _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          selectable: _vm.checkSel,
                          width: "50",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "订单号", width: "115" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "dnone" }, [
                              _vm._v(
                                "【AGENT：" +
                                  _vm._s(scope.row.agent_id) +
                                  "】【APPID：" +
                                  _vm._s(scope.row.appid) +
                                  "】"
                              ),
                            ]),
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.order_sn) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "交易单号", width: "142" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.transaction_id) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商户单号", width: "142" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.out_order_no) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "类型", width: "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.goods_name) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "来源", width: "70" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.mini_type == 1 ? "微信" : "支付宝"
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "支付类型", width: "90" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.nfc_no
                              ? _c("div", { staticClass: "fs-s3" }, [
                                  _vm._v(
                                    "储值卡支付(" +
                                      _vm._s(scope.row.nfc_no) +
                                      ")"
                                  ),
                                ])
                              : _c("div", { staticClass: "fs-s3" }, [
                                  _vm._v(_vm._s(scope.row.new_deposit_status)),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "用户ID", width: "70" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.uid) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "用户", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex align-center" },
                              [
                                _c("el-avatar", {
                                  staticClass: "mr-5",
                                  attrs: {
                                    size: 25,
                                    src: scope.row.user_avatar,
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm.config.system_other.order_amount_show ||
                                  _vm.checkRoles(
                                    _vm.config.system_other.have_role
                                  )
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(scope.row.user_mobile) +
                                            "\n                "
                                        ),
                                      ])
                                    : _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.dealPhone(scope.row.user_mobile)
                                          )
                                        ),
                                      ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-cut" }, [
                                    _vm._v(
                                      _vm._s(scope.row.user_nick_name || "--")
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商户", "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "flex" }, [
                              _c("div", [_vm._v("租用：")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex1" }, [
                                _vm._v(_vm._s(scope.row.rent_store || "--")),
                              ]),
                            ]),
                            _vm._v(" "),
                            scope.row.depend_type == 0
                              ? _c("div", { staticClass: "flex" }, [
                                  _c("div", [_vm._v("归还：")]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex1" }, [
                                    _vm._v(
                                      _vm._s(scope.row.back_store || "--")
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "时间", width: "200" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "开始：" +
                                  _vm._s(scope.row.charge_start || "--")
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "结束：" + _vm._s(scope.row.charge_end || "--")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "设备SN码", width: "220" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                "二维码：" + _vm._s(scope.row.zuo_sn || "--")
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "设备SN：" + _vm._s(scope.row.device_id || "--")
                              ),
                            ]),
                            _vm._v(" "),
                            scope.row.depend_type == 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "text-cut cursor text-blue",
                                    on: {
                                      click: function ($event) {
                                        return _vm.checkBao(scope.row.goods_sn)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "宝SN码：" +
                                        _vm._s(scope.row.goods_sn || "--")
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "套餐", width: "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.rent_desc || "--") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.config.system_other.order_amount_show ||
                  _vm.checkRoles(_vm.config.system_other.have_role)
                    ? _c("el-table-column", {
                        staticStyle: { padding: "0" },
                        attrs: { label: "收益(元)", width: "75" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    { attrs: { type: "success" } },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.money_paid || "--")
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1184985770
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.config.system_other.order_amount_show ||
                  _vm.checkRoles(_vm.config.system_other.have_role)
                    ? _c("el-table-column", {
                        attrs: { label: "退款(元)", width: "75" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-link",
                                    { attrs: { type: "success" } },
                                    [
                                      _vm._v(
                                        _vm._s(scope.row.refund_drawbacked)
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1012990786
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "70" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: {
                                  type:
                                    scope.row.order_status > 2 ||
                                    scope.row.order_status == -1
                                      ? "danger"
                                      : "success",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.orderStatus[scope.row.order_status] ||
                                        "--"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "备注", "min-width": "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "remark-box" },
                              [
                                scope.row.steal_type_des
                                  ? _c(
                                      "div",
                                      { staticClass: "fs-s4 text-danger" },
                                      [_vm._v(_vm._s(scope.row.steal_type_des))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.remark
                                  ? _c(
                                      "el-link",
                                      { attrs: { type: "danger" } },
                                      [_vm._v(_vm._s(scope.row.remark))]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.favourable_type == 3
                                  ? _c(
                                      "el-link",
                                      { attrs: { type: "danger" } },
                                      [_vm._v("【VIP会员】")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.delivery_status == 2
                                  ? _c("div", { staticClass: "fs-s4" }, [
                                      _vm._v(
                                        "补宝备注：" +
                                          _vm._s(scope.row.delivery_sn)
                                      ),
                                    ])
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "异常退款", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  scope.row.is_cancel_commission == 1 ? "✔" : ""
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "110",
                      fixed: _vm.device == "desktop" ? "right" : false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.config.system_other.order_amount_show ||
                            _vm.checkRoles(_vm.config.system_other.have_role)
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "ml-10",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getOrderDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("订单详情\n            ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.refund_apply_status == 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.upApply(scope.row, 1)
                                      },
                                    },
                                  },
                                  [_vm._v("通过申请")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.refund_apply_status == 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.upApply(scope.row, 0)
                                      },
                                    },
                                  },
                                  [_vm._v("驳回申请")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.refund_apply_status > 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.refundInfo(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("退款详情")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.refund_apply_status != 1
                              ? [
                                  _vm.agentInfo.drawback_order == 1 &&
                                  (scope.row.money_paid > 0 ||
                                    (scope.row.steal_type == 1 &&
                                      scope.row.deposit_amount > 0)) &&
                                  (!scope.row.refund_drawbacked ||
                                    scope.row.refund_drawbacked == 0)
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleRefundClick(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("订单退款")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  (scope.row.order_status == 1 ||
                                    scope.row.order_status == 0) &&
                                  _vm.agentInfo.finish_order == 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.endOrder(1, scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("结束订单")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkRoles(["partner"]) &&
                                  scope.row.night_fee > 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.nightfeeRefund(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("退服务费")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.steal_type != 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.stealRestore(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("恢复订单")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.is_cancel_commission == 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelRestore(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("恢复异常退款订单")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.is_recover == 0
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "warning",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.recoverDegree(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("恢复度数")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.checkRoles(["partner"]) &&
                                  scope.row.delivery_status == 1
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            plain: "",
                                            round: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deliver(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("立即发货\n              ")]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkRoles(["partner", "terminal"]) &&
                            _vm.listQuery.order_type == 7
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      round: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deduct(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("立即扣款")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.outStatus
                ? _c(
                    "div",
                    { staticClass: "flex justify-center" },
                    [
                      _c("pagination", {
                        attrs: {
                          total:
                            _vm.list.length == _vm.listQuery.limit
                              ? (_vm.listQuery.start + 1) * _vm.listQuery.limit
                              : _vm.listQuery.start * _vm.listQuery.limit,
                          page: _vm.listQuery.start,
                          limit: _vm.listQuery.limit,
                          layout: "sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "update:page": function ($event) {
                            return _vm.$set(_vm.listQuery, "start", $event)
                          },
                          "update:limit": function ($event) {
                            return _vm.$set(_vm.listQuery, "limit", $event)
                          },
                          pagination: _vm.getList,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "订单详情", visible: _vm.detailDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.detailDialog = $event
                },
              },
            },
            [
              _vm.checkRoles(["partner"]) && _vm.order.charging_power_min
                ? _c("span", [
                    _vm._v(
                      "使用功率范围：" +
                        _vm._s(_vm.order.charging_power_min) +
                        "-" +
                        _vm._s(_vm.order.charging_power_max)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "el-timeline",
                _vm._l(_vm.order.operate_flow, function (item, index) {
                  return _c(
                    "el-timeline-item",
                    {
                      key: index,
                      attrs: { placement: "top", timestamp: item.date },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(item.event) + " ---> " + _vm._s(item.result)
                        ),
                      ]),
                      _vm._v(" "),
                      item.reason
                        ? _c(
                            "div",
                            { staticClass: "mt-5" },
                            [
                              _c("el-link", { attrs: { type: "danger" } }, [
                                _vm._v(_vm._s(item.reason)),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.siteInfo.order_profits_detail_show == 1 ||
              _vm.checkRoles(_vm.config.system_other.have_role)
                ? [
                    _c("div", { staticClass: "flex mb-10 text-center" }, [
                      _c("div", { staticClass: "flex1" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [
                        _vm._v(
                          "分成明细：" + _vm._s(_vm.order.money_paid) + " "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.checkRoles(["partner"]) &&
                      _vm.order.night_fee != "0.00"
                        ? _c("div", { staticClass: "flex1" }, [
                            _vm._v(
                              "夜间服务费：" +
                                _vm._s(_vm.order.night_fee) +
                                "元 "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex mb-10 text-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "flex2",
                          staticStyle: { width: "4rem", "text-align": "left" },
                        },
                        [_vm._v("分成人")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [_vm._v("分成比例")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [_vm._v("分成金额")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex1" }, [_vm._v("退款金额")]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.order.agents_profit, function (item) {
                      return [
                        item.agent_level >= _vm.agentInfo.agent_level
                          ? _c(
                              "div",
                              { staticClass: "flex mb-10 text-center" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex2",
                                    staticStyle: {
                                      width: "4rem",
                                      "text-align": "left",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(item.agent_name) +
                                        "：" +
                                        _vm._s(item.parent_name)
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm._v(_vm._s(item.profit_percent)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm._v(_vm._s(item.get_profit) + "元"),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex1" }, [
                                  _vm._v(_vm._s(item.drawback_profit) + "元"),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "结束订单", visible: _vm.endOrderDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.endOrderDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "140px" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.order.depend_type == 0
                            ? "归还时间："
                            : "结束时间：",
                        prop: "name",
                      },
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetime",
                          "value-format": "timestamp",
                          placeholder:
                            _vm.order.depend_type == 0
                              ? "归还时间："
                              : "结束时间：",
                          "picker-options": _vm.endOptions,
                        },
                        model: {
                          value: _vm.endOrderObj.return_time,
                          callback: function ($$v) {
                            _vm.$set(_vm.endOrderObj, "return_time", $$v)
                          },
                          expression: "endOrderObj.return_time",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.order.depend_type == 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "检测设备是否归还：" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.endOrderObj.check_bao_backed,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.endOrderObj,
                                  "check_bao_backed",
                                  $$v
                                )
                              },
                              expression: "endOrderObj.check_bao_backed",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.endOrderDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.clickSubmit },
                      on: {
                        click: function ($event) {
                          return _vm.endOrder(2, _vm.order)
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "订单退款", visible: _vm.refundDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.refundDialog = $event
                },
              },
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "130px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "退款方式：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.refundObj.refund_2_balance,
                            callback: function ($$v) {
                              _vm.$set(_vm.refundObj, "refund_2_balance", $$v)
                            },
                            expression: "refundObj.refund_2_balance",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("退回小程序钱包"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("原路退回"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "退款金额：" } },
                    [
                      _c(
                        "el-input",
                        {
                          model: {
                            value: _vm.refundObj.refund_money,
                            callback: function ($$v) {
                              _vm.$set(_vm.refundObj, "refund_money", $$v)
                            },
                            expression: "refundObj.refund_money",
                          },
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _vm._v("元"),
                            _vm.order.steal_type == 1 &&
                            _vm.order.deposit_amount > 0 &&
                            _vm.order.deposit_amount > _vm.order.money_paid &&
                            _vm.order.order_status == 1
                              ? _c(
                                  "span",
                                  { staticClass: "el-link el-link--danger" },
                                  [
                                    _vm._v(
                                      "（最多" +
                                        _vm._s(
                                          _vm.order.deposit_amount -
                                            _vm.order.money_paid
                                        ) +
                                        "元）"
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "el-link el-link--danger" },
                                  [
                                    _vm._v(
                                      "（最多" +
                                        _vm._s(_vm.order.money_paid) +
                                        "元）"
                                    ),
                                  ]
                                ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "退款原因：" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.refundObj.refund_reason,
                          callback: function ($$v) {
                            _vm.$set(_vm.refundObj, "refund_reason", $$v)
                          },
                          expression: "refundObj.refund_reason",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "fs-s2 text-gray" }, [
                        _vm._v(
                          "注：非必填信息，若填写将展示在下发给用户的退款消息中。"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.refundDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", disabled: _vm.clickSubmit },
                      on: {
                        click: function ($event) {
                          return _vm.refundOrder(_vm.order)
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "宝详情",
                visible: _vm.baoDialog,
                top: "36vh",
                width: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.baoDialog = $event
                },
              },
            },
            [
              _c(
                "el-table",
                { attrs: { data: _vm.baoList } },
                [
                  _c("el-table-column", {
                    attrs: { label: "SN" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v("底座：" + _vm._s(scope.row.device_id)),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("宝：" + _vm._s(scope.row.B1))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "基本信息" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v("槽口：" + _vm._s(scope.row.B2)),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v("电量：" + _vm._s(scope.row.B3) + "%"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "电线：" +
                                  _vm._s(scope.row.B4 == 0 ? "正常" : "故障")
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "电池：" +
                                  _vm._s(scope.row.B5 == 0 ? "正常" : "故障")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-link", { attrs: { type: "danger" } }, [
                              _vm._v(_vm._s(_vm.baoStatus[scope.row.status])),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "弹出次数", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.used_num) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "最新时间", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.parseTime(
                                    scope.row.updated,
                                    "{y}-{m}-{d} {h}:{i}:{s}"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: { title: "退款详情", visible: _vm.washRefundDialog },
              on: {
                "update:visible": function ($event) {
                  _vm.washRefundDialog = $event
                },
              },
            },
            [
              _c("div", { staticClass: "mt-10 mb-15" }, [
                _c("span", { staticClass: "text-gray" }, [
                  _vm._v("退款状态："),
                ]),
                _vm._v(_vm._s(_vm.refundStatus[_vm.washRefund.refund_status])),
              ]),
              _vm._v(" "),
              _vm.washRefund.refuse_reason
                ? _c("div", { staticClass: "mt-10 mb-15" }, [
                    _c("span", { staticClass: "text-gray" }, [
                      _vm._v("拒绝原因："),
                    ]),
                    _vm._v(_vm._s(_vm.washRefund.refuse_reason)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "mt-10 mb-15" }, [
                _c("span", { staticClass: "text-gray" }, [
                  _vm._v("手机号码："),
                ]),
                _vm._v(_vm._s(_vm.washRefund.mobile)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-10 mb-15" }, [
                _c("span", { staticClass: "text-gray" }, [
                  _vm._v("退款金额："),
                ]),
                _vm._v(_vm._s(_vm.washRefund.refund_money) + "元"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex mt-10 mb-15" }, [
                _c("div", { staticClass: "text-gray" }, [_vm._v("问题描述：")]),
                _vm._v(" "),
                _c("div", { staticClass: "flex1" }, [
                  _vm._v(_vm._s(_vm.washRefund.refund_reason || "未填写")),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex mt-10 mb-15" }, [
                _c("div", { staticClass: "text-gray" }, [_vm._v("错误截图：")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex1" },
                  _vm._l(_vm.washRefund.refund_img_url, function (item) {
                    return _c("el-image", {
                      staticClass: "mr-5",
                      staticStyle: { width: "50px", height: "50px" },
                      attrs: {
                        src: item,
                        "preview-src-list": _vm.washRefund.refund_img_url,
                      },
                    })
                  }),
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.excel,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                title: "导出加载进度",
                width: "240px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.excel = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c("el-progress", {
                    attrs: { type: "circle", percentage: _vm.percentage },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "设备排序设置-拖拽排序",
                visible: _vm.deviceSortDialog,
                width: "400px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.deviceSortDialog = $event
                },
              },
            },
            [
              _c(
                "el-table",
                {
                  ref: "dragDevice",
                  attrs: {
                    data: _vm.deviceSortArr,
                    "row-key": "depend_type",
                    border: "",
                    fit: "",
                    "highlight-current-row": "",
                    "show-header": false,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { align: "center", label: "设备类型" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("span", { staticClass: "cursor" }, [
                              _vm._v(_vm._s(row.depend_name)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.deviceSortDialog = false
                        },
                      },
                    },
                    [_vm._v("取 消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.postDeviceSort(2, _vm.order)
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "center-header-dialog",
          attrs: {
            title: "",
            visible: _vm.orderStatsDialogVisible,
            top: "50px",
            left: "575px",
            width: "1260px",
            "before-close": _vm.handleOrderStatsClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderStatsDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "device-chart-title" }, [
            _vm._v("\n      订单交易总计\n    "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "device-chart-container" }, [
            _c(
              "div",
              { staticClass: "chart-filter" },
              [
                _c("el-date-picker", {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    type: "daterange",
                    "range-separator": "至",
                    "start-placeholder": "开始日期",
                    "end-placeholder": "结束日期",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd HH:mm:ss",
                    size: "small",
                  },
                  on: { change: _vm.switchCustomPeriod },
                  model: {
                    value: _vm.customPeriodRange,
                    callback: function ($$v) {
                      _vm.customPeriodRange = $$v
                    },
                    expression: "customPeriodRange",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.periodOptions, function (period) {
                  return _c(
                    "el-button",
                    {
                      key: period.value,
                      attrs: {
                        type:
                          _vm.currentPeriod === period.value
                            ? "primary"
                            : "default",
                        size: "small",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.switchPeriod(period.value)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(period.label) + "\n        "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "chart-summary" }, [
              _c("div", { staticClass: "summary-item" }, [
                _c("span", [_vm._v("合计:")]),
                _vm._v(" "),
                _c("span", { staticClass: "amount total" }, [
                  _vm._v("¥" + _vm._s(_vm.summary.total)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.chartLoading,
                    expression: "chartLoading",
                  },
                ],
                attrs: { "element-loading-text": "数据加载中..." },
              },
              [
                _c("div", {
                  staticClass: "device-chart",
                  attrs: { id: "deviceChart" },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-card",
            { staticClass: "explanation-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v("统计说明"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "explanation-content" }, [
                _c("p", [
                  _c("strong", [_vm._v("各设备数量：")]),
                  _vm._v(
                    "统计当前管理账号关联的各种设备类型的总量，0充电宝、1密码线、3充电桩、7套套机，其中寄存柜、无人机、汽车桩暂无可聚合数据。"
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("订单交易额：")]),
                  _vm._v(
                    "统计当前时间段内所有订单的交易总额，包含微信、支付宝等不同支付方式的金额总和，并用当前交易总额减手续费为交易收入额"
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.orderStatsDialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }